/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { DockHudUI } from "components/hud/DockHudUI";
import { getIsHUDDocked } from "selectors/hudSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  isDocked: getIsHUDDocked(stores),
  componentsOnRight: stores.hudStore.getRightAlignedExternalComponents,
  onDockViewChange: () => {
    const isCurrentlyDocked = getIsHUDDocked(stores);
    stores.hudStore.setIsDocked(!isCurrentlyDocked);
  }
});

const DockHUDContainer = inject(mapStoreToProps)(DockHudUI);

export { DockHUDContainer };
